/**
 *
 * @module entry
 * @desc {SDK.Device} entry point.
 *
 */

import DeviceManager from './deviceManager';

/**
 *
 * @typedef SDK.Device
 * @type {Object}
 *
 * @property {DeviceManager} DeviceManager
 *
 */

/**
 *
 * @type {SDK.Device}
 *
 */
export default {

    DeviceManager

};



// WEBPACK FOOTER //
// ./src/device/entry.js